import React, { useEffect, useState } from "react";
import axiosInstance from "../../utils/config/config";
import { useSelector } from "react-redux";

const TransactionsHistory = ({ userId }) => {
  const [stripePayments, setStripePayments] = useState([]);
  const [internalTransactions, setInternalTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [lastId, setLastId] = useState(null);
  const [hasMore, setHasMore] = useState(false);
  const { userData } = useSelector((state) => state.user);

  const fetchTransactions = async (startAfter = null) => {
    try {
      setLoading(true);
      setError(null);
      const res = await axiosInstance.get(`/user/stripeTransactionsHistory`, {
        params: {
          userId: userData.id,
          startingAfter: startAfter,
          limit: 10,
        },
      });
      setStripePayments(res.data.stripePayments.data || []);
      setInternalTransactions(res.data.transactionHistories || []);
      setLastId(res.data.lastId);
      setHasMore(res.data.hasMore);
    } catch (err) {
      setError("Failed to fetch transactions.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [userId]);

  return (
    <div className="p-4 max-w-3xl mx-auto">
      <h2 className="text-xl font-semibold mb-4">Transaction History</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}

      {/* <h3 className="text-lg font-bold mt-6 mb-2">💳 Stripe Payments</h3>
      {stripePayments.length === 0 && <p>No Stripe payments found.</p>}
      <ul className="space-y-4">
        {stripePayments.map((txn) => (
          <li key={txn.id} className="border p-4 rounded-xl shadow-sm">
            <p>
              <strong>ID:</strong> {txn.id}
            </p>
            <p>
              <strong>Amount:</strong> ${(txn.amount / 100).toFixed(2)}{" "}
              {txn.currency.toUpperCase()}
            </p>
            <p>
              <strong>Status:</strong> {txn.status}
            </p>
            <p>
              <strong>Date:</strong>{" "}
              {new Date(txn.created * 1000).toLocaleString()}
            </p>
          </li>
        ))}
      </ul> */}

      <h3 className="text-lg font-bold mt-8 mb-2">🧾 Transaction Logs</h3>
      {internalTransactions.length === 0 && (
        <p>No internal transactions found.</p>
      )}
      <ul className="space-y-4">
        {internalTransactions.map((txn) => (
          <li key={txn.id} className="border p-4 rounded-xl shadow-sm">
            <p>
              <strong>ID:</strong> {txn.id}
            </p>
            <p>
              <strong>Package:</strong> {txn.packageName}
            </p>
            <p>
              <strong>Price:</strong> {txn.price === null ? 0 : txn.price}
            </p>
            <p>
              <strong>Message:</strong> {txn.transactionMessage}
            </p>
            <p>
              <strong>Date:</strong> {new Date(txn.createdAt).toLocaleString()}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TransactionsHistory;
